// v2.0
import CryptoJS from 'crypto-js';
import aes from 'crypto-js/aes';
import encHex from 'crypto-js/enc-hex';
import padZeroPadding from 'crypto-js/pad-zeropadding';

export function getRanHex(size) {
    let result = [];
    let hexRef = [
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        'a',
        'b',
        'c',
        'd',
        'e',
        'f',
    ];

    for (let n = 0; n < size; n++) {
        result.push(hexRef[Math.floor(Math.random() * 16)]);
    }
    return result.join('');
}

export function encrypt(data, secret_key) {
    const string_convert = JSON.stringify(data);
    let key = encHex.parse(secret_key);
    let iv = encHex.parse(secret_key);
    let encrypted = aes
        .encrypt(string_convert, key, { iv: iv, padding: padZeroPadding })
        .toString();
    return encrypted;
}

export function decrypt(encrypted, secret_key) {
    let key = encHex.parse(secret_key);
    let iv = encHex.parse(secret_key);
    let data = aes
        .decrypt(encrypted, key, { iv: iv, padding: padZeroPadding })
        .toString(CryptoJS.enc.Utf8);
    return JSON.parse(data);
}

export function base64Encoder(str) {
    const encodedWord = CryptoJS.enc.Utf8.parse(str);
    const encoded = CryptoJS.enc.Base64.stringify(encodedWord);
    return encoded;
}
